import http from '@/utils/http'

// 获取字典 - 员工异动数据源
export const getYidongDict = (): IResponseType<any> =>
  http.request({
    url: '/hrm/movement/field',
    method: 'get',
    params: {flow_dic: 0}
  })
